import {Chip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";
import React, {useContext, useState} from "react";
import {TableHead} from "../../system/thead";
import {PaginateContext} from "../../../context/paginate";


const TABLE_HEAD = ["#", "کاربر", "مباشر", "رشته", "گرایش", "پرداخت", "مبلغ", "تاریخ", "زمان", "مدت", "وضعیت"];

export function ConsultationReportGrid({
                                         consultationReport,
                                       }) {

  const [selectedHead, setSelectedHead] = useState("#")

  const {
    setSortBy,
    sortType,
    setSortType,
  } = useContext(PaginateContext)

  const headMap = {
    "#": "",
    "کاربر": "person_name",
    "مباشر": "agent_name",
    "رشته": "field_title",
    "گرایش": "branch_title",
    "تاریخ": "date",
    "زمان": "start_time",
    "مدت": "duration",
    "وضعیت": "status",
    "مبلغ": "price",
    "پرداخت": "paid_at",
  }

  const headSortable = {
    "#": false,
    "کاربر": true,
    "مباشر": true,
    "رشته": true,
    "گرایش": true,
    "تاریخ": true,
    "زمان": true,
    "مدت": true,
    "وضعیت": true,
    "مبلغ": true,
    "پرداخت": true,
  }

  return (
    <div className="w-full border border-blue-gray-100 rounded-xl overflow-hidden">
      <table className="w-full table-fixed text-left">
        <TableHead
          tableHead={TABLE_HEAD}
          headSortable={headSortable}
          headMap={headMap}
          sortType={sortType}
          setSortType={setSortType}
          setSortBy={setSortBy}
          selectedHead={selectedHead}
          setSelectedHead={setSelectedHead}
        />
        <tbody className="textCenter divide-y divide-blue-gray-100">
        {consultationReport.map(
          ({
             id,
             person_name,
             person_phone,
             agent_name,
             agent_phone,
             type,
             field_title,
             branch_title,
             date,
             start_time,
             end_time,
             duration,
             status,
             price,
             paid_at
           }, index) => {
            const isLast = index === consultationReport.length - 1;
            const classes = "p-4";

            return (
              <tr key={id}>

                <td className={classes}>
                  <div className="flex justify-center">
                    <Typography color="blue-gray">
                      {persianNumberFormat(index + 1, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {person_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(person_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {agent_name}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(agent_phone)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {field_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {branch_title}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    {paid_at?.length > 0 &&
                      <>
                        <Typography color="blue-gray">
                          {persianNumberFormat(paid_at.split(" ")[0])}
                        </Typography>
                        <Typography color="blue-gray">
                          {persianNumberFormat(paid_at.split(" ")[1])}
                        </Typography>
                      </>
                    }
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Typography color="blue-gray" className="textRight">
                      {persianNumberFormat(price, true)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(date)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(start_time)}
                    </Typography>
                    <Typography color="blue-gray">
                      {persianNumberFormat(end_time)}
                    </Typography>
                  </div>
                </td>


                <td className={classes}>
                  <div className="flex flex-col justify-center px-4">
                    <Typography color="blue-gray">
                      {persianNumberFormat(duration)}
                    </Typography>
                  </div>
                </td>

                <td className={classes}>
                  <div className="flex justify-center px-4">
                    <Chip
                      variant="ghost"
                      value={status === 'enable' ? "فعال" :
                        status === 'disable' ? 'عیر فعال' :
                          status === 'payment' ? 'درحال انجام' :
                            status === 'waiting' ? 'در انتظار تسویه' :
                              status === 'finish' ? 'اتمام خدمت' :
                                status}
                      color={status === 'new' ? "cyan" :
                        status === 'disable' ? 'amber' :
                          status === 'payment' ? 'indigo' :
                            status === 'waiting' ? 'indigo' :
                              status === 'enable' ? 'green' :
                                status}
                    />
                  </div>
                </td>

              </tr>
            );
          },
        )}
        </tbody>
      </table>
    </div>
  );
}